import { Button, Table } from '@scuf/common';
import Alert from 'components/alert';
import useFetch from 'helpers/hooks/useFetch';
import {
    workOrderDefaultStatus,
    WorkOrderOption,
    WorkOrderRmaLiteDto,
    workOrderStatus
} from 'models';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { REPAIR_CENTER } from 'resources';

interface ChangeStatusProps {
    rmaId: number;
}

function AdmWorkOrdersAccordion({ rmaId }: ChangeStatusProps): JSX.Element {
    const { t } = useTranslation(['repaircenter', 'common']);

    const [dados, getRmaDetailsComOs, loading] =
        useFetch<{ Id: number }>({
            url: REPAIR_CENTER.getRmaDetails,
            redirectOnError: true
        });

    useEffect(() => {
        getRmaDetailsComOs({ Id: rmaId });
    }, [rmaId]);

    const [, updateStatusOS, updateLoading] = useFetch<{ workOrderNumber: string | number, rmaNumber: number }>({
        url: REPAIR_CENTER.updateStatusOS,
        method: 'DELETE',
        onError: 'Change',
        onSuccess: 'Change'
    });

    const handleChangeStatus = async (numberOS: string | number) => {
        if (!dados?.data) { return; }
        await updateStatusOS({ workOrderNumber: numberOS, rmaNumber: dados.data.id });
        await getRmaDetailsComOs({ Id: rmaId });
    }

    return (
        loading ? (<Alert icon='info' text={t('common:actions.Loading')} />) : (dados?.data?.workOrders?.length > 0 && (
            <Table>
                <Table.Header>
                    <Table.HeaderCell>{t('common:translation.Number')}</Table.HeaderCell>
                    <Table.HeaderCell>{t('common:status.Approved')}</Table.HeaderCell>
                    <Table.HeaderCell>{t('common:translation.Status')}</Table.HeaderCell>
                    <Table.HeaderCell>{t('rma.admin.os.ChangeStatusOS')}</Table.HeaderCell>
                </Table.Header>
                {dados?.data?.workOrders?.map((workOrder: WorkOrderRmaLiteDto) => (
                    <Table.Row>
                        <Table.Cell>{workOrder.os}</Table.Cell>
                        <Table.Cell>
                            {workOrder.flagApproved === -1
                                ? ' - '
                                : workOrder.flagApproved === 2
                                    ? t('common:status.Pending')
                                    : workOrder.flagApproved === 0
                                        ? t('common:actions.No')
                                        : t('common:actions.Yes')}
                        </Table.Cell>
                        <Table.Cell>
                            {workOrderStatus.find((e: WorkOrderOption) => e.text.includes(workOrder.status))?.text ??
                                workOrderDefaultStatus.text}
                        </Table.Cell>
                        <Table.Cell>
                            <Button
                                size="small"
                                type='secondary'
                                loading={updateLoading}
                                disabled={workOrder.flagApproved === 2 || updateLoading || workOrder.flagApproved === -1}
                                onClick={() => handleChangeStatus(workOrder.os)}
                            >
                                {t('common:actions.Change')}
                            </Button>
                        </Table.Cell>
                    </Table.Row>
                ))}
            </Table>
        )) || <Alert text={t('common:empty.NoWorkOrders')} />)
}

export default AdmWorkOrdersAccordion;
